
export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    appendIcon: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    focusOnAppendClick: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasAppend() {
      return !!this.$slots.append;
    },
    hasOnAppendClick() {
      return Boolean(this.$listeners?.["click:append"]);
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
  methods: {
    onAppendClick(event) {
      this.$emit("click:append", event);
      if (this.focusOnAppendClick) {
        if (this.$refs.inputEl) {
          this.$refs.inputEl.focus();
        }
      }
    },
  },
};
